import React from 'react';
import { Environment } from 'src/Environment';
import {
  Application,
  ApplicationAction,
  IFeesService,
  ISalesforceService,
  Wizard,
  WizardContextProvider,
  useCatalogue,
} from 'src/features/common';
import TechnicalError from 'src/features/common/components/technical-error/technical-error';
import { ApplicationProvider } from 'src/features/device-activation/context/application-context';
import { IDeviceActivationTealiumService } from 'src/services/tealium/device-activation/device-activation-tealium-service';
import { IDpoTealiumService } from 'src/services/tealium/dpo/dpo-tealium-service';

export interface DeviceActivationAppProps {
  basePath: string;
  application: Application;
  pageNameMap: Map<string, React.ReactFragment>;
  salesforceService: ISalesforceService;
  dispatch: React.Dispatch<ApplicationAction>;
  feesService: IFeesService;
  deviceActivationTealiumService: IDeviceActivationTealiumService;
  dpoTealiumService: IDpoTealiumService;
}

export function DeviceActivationApp(props: DeviceActivationAppProps) {
  const [catalogue] = useCatalogue(props.salesforceService, props.feesService, props.application);

  return (
    <div>
      <TechnicalError>
        <ApplicationProvider
          application={props.application}
          dispatch={props.dispatch}
          salesforceService={props.salesforceService}
          catalogue={catalogue}
          deviceActivationTealiumService={props.deviceActivationTealiumService}
          dpoTealiumService={props.dpoTealiumService}
        >
          <WizardContextProvider>
            <Wizard
              application={props.application}
              pageNameMap={props.pageNameMap}
              basePath={props.basePath}
              dispatch={props.dispatch}
              automationIdPrefix="Device_Activation_POS_Light"
              dpo={!Environment.current.disabledFeatures.dpo}
            />
          </WizardContextProvider>
        </ApplicationProvider>
      </TechnicalError>
    </div>
  );
}
